unit UColumnModel;

interface

uses
  Js;

type
  TColumnModel = class
  private
    FZeitartIds: string;
    FInTagen: Boolean;
    FBezeichnung: string;
    FPosition: Integer;
    procedure ClearValues;
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetBezeichnung(const Value: string);
    procedure SetInTagen(const Value: Boolean);
    procedure SetPosition(const Value: Integer);
    procedure SetZeitartIds(const Value: string);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    function CompareTo(other: TColumnModel): Integer;
    function IsEqual(other: TColumnModel): Boolean;
    procedure CopyFrom(other: TColumnModel);
    property Position: Integer read FPosition write SetPosition;
    property Bezeichnung: string read FBezeichnung write SetBezeichnung;
    property ZeitartIds: string read FZeitartIds write SetZeitartIds;
    property InTagen: Boolean read FInTagen write SetInTagen;
  end;

implementation

uses
  System.SysUtils, UEssentialHelper;

{ TColumnModel }

procedure TColumnModel.ClearValues;
begin
  Self.Position:=0;
  Self.Bezeichnung:='';
  Self.ZeitartIds:='';
  Self.InTagen:=false;
end;

constructor TColumnModel.Create;
begin
  Self.ClearValues;
end;

function TColumnModel.CompareTo(other: TColumnModel): Integer;
begin
  if other<>nil then begin
    if Self.IsEqual(other) then
      Result:=0
    else if Self.Position<other.Position then
      Result:=-1
    else
      Result:=1;
  end
  else
    Result:=-1;
end;

procedure TColumnModel.CopyFrom(other: TColumnModel);
begin
  if other<>nil then begin
    Self.Position:=other.Position;
    Self.Bezeichnung:=other.Bezeichnung;
    Self.ZeitartIds:=other.ZeitartIds;
    Self.InTagen:=other.InTagen;
  end;
end;

constructor TColumnModel.Create(json: string);
begin
  Self.SetValues(json);
end;

function TColumnModel.IsEqual(other: TColumnModel): Boolean;
begin
  if other<>nil then
    Result:=other.Position=Self.Position
  else
    Result:=false;
end;

procedure TColumnModel.SetBezeichnung(const Value: string);
begin
  FBezeichnung := Value;
end;

procedure TColumnModel.SetInTagen(const Value: Boolean);
begin
  FInTagen := Value;
end;

procedure TColumnModel.SetPosition(const Value: Integer);
begin
  FPosition := Value;
end;

procedure TColumnModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['Position']<>nil then
    Self.Position:=StrToInt(string(obj['Position']));
  if obj['Bezeichnung']<>nil then
    Self.Bezeichnung:=string(obj['Bezeichnung']);
  if obj['ZeitartIds']<>nil then
    Self.ZeitartIds:=string(obj['ZeitartIds']);
  if obj['InTagen']<>nil then
    Self.InTagen:=StrToBoolean(string(obj['InTagen']));
end;

procedure TColumnModel.SetValues(json: string);
var obj: TJsObject;
begin
  obj:=TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

procedure TColumnModel.SetZeitartIds(const Value: string);
begin
  FZeitartIds := Value;
end;

end.
